<div class="section-list card ">
    <div class="card-header">
        <ng-template #loadingtemplate>
            <span>Loading</span>
        </ng-template>
        <nav
            class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header mb-2 nav-bar-transparent">
            <div class="section-header">
                <div class="section-icon"><i class="fa-tachometer-alt fas menu-icon"></i> Portfolio Status</div>
            </div>
            <div class="d-flex">

                <div class="summary-title dashboard-summary" *ngIf="!firstload else loadingtemplate">
                    <div class="summary-line"><i class="fa-globe-americas fas text-primary"></i>
                        {{filterTotal.totalsites}}
                        Sites
                    </div>
                    <div class="summary-line"><i class="fas fa-battery-three-quarters text-success"></i>
                        {{filterTotal.totalpower | watts:1000000}}
                    </div>
                    <div class="summary-line"><i class="fas fa-battery-quarter text-danger"></i>
                        {{filterTotal.totalpowerlost | watts}}
                        <!-- {{filterTotal.totalpowerlostpercent | number: '1.0-2'}}% -->
                        Lost
                    </div>
                    <div class="summary-line"><i class="fas fa-th-large text-danger"></i>
                        {{filterTotal.totalmodulesinactive | number: '1.0-0'}} Damaged modules
                    </div>
                </div>
            </div>
            <div class="ml-auto mr-1">
                <ul class="nav navbar-nav ml-auto">
                    <li class="nav-item" style="width:300px;">
                        <app-site-filter2 #filterbysite [automaticLoad]="false" [list]="siteList"
                            [myplaceholder]="'Site'" (onSiteSelected)="siteAutoComplete_optionSelected($event)">
                        </app-site-filter2>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" role="button" (click)="filterOpenModal();false"
                            matTooltip="Click here to filter data for dashboard">
                            <i class="fas fa-filter"></i>
                        </a>
                    </li>
                    <li class="nav-item dropdown" dropdown placement="bottom right">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                            aria-expanded="false" dropdownToggle (click)="false"
                            matTooltip="Choose charts to show on dashboard">
                            <i class="fas fa-chart-bar"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown1">
                            <div class="dropdown-header">Show Hide Charts</div>
                            <a class="dropdown-item" (click)="changeSitePowerChartVisibility(showChartPower);">
                                <app-check-box-icon [checked]="showChartPower.visible"></app-check-box-icon> Site power
                            </a>

                            <a class="dropdown-item" (click)="showChartIssues=!showChartIssues">
                                <app-check-box-icon [checked]="showChartIssues"></app-check-box-icon> Issues By type
                            </a>
                            <a class="dropdown-item" (click)="showChartRelevance=!showChartRelevance">
                                <app-check-box-icon [checked]="showChartRelevance"></app-check-box-icon> Issues By
                                relevance
                            </a>
                            <a class="dropdown-item" (click)="showChartManufacturer=!showChartManufacturer">
                                <app-check-box-icon [checked]="showChartManufacturer"></app-check-box-icon> Panel
                                manufacturer
                            </a>
                            <a class="dropdown-item" (click)="showChartPanelModel=!showChartPanelModel">
                                <app-check-box-icon [checked]="showChartPanelModel"></app-check-box-icon> Panel model
                            </a>
                            <div class="dropdown-header">Options</div>
                            <a class="dropdown-item" (click)="hideChartPowerWhen1=!hideChartPowerWhen1">
                                <app-check-box-icon [checked]="hideChartPowerWhen1"></app-check-box-icon> Hide site
                                power when there is only 1 site
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    </div>



    <div class="card-body1 container-card-body1">
        <!--   <div class="db-filter">
    <app-db-filter2 #dbfilter2 [dbFilter]="dbFilter"></app-db-filter2>
</div>    -->
        <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
        <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
        <!-- map -->
        <div class="dashboard-map withnav">
            <app-ol-main #map_db *ngIf="mapcontrol" [showCardTitle]="false" [showButtonLayers]="true">
            </app-ol-main>
            <div #mapTooltip id="mapTooltip" class="map_tooltip">TOOLTIP</div>
        </div>
        <!-- map end-->

        <div class="chart-container-trans">
            <perfect-scrollbar class="chart-perfect-scrollbar">
                <div class="chart-container" *ngIf="showChartPower.visible"
                [@enterAnimation]>
                    <div style="height: 300px;">
                        <app-frms-chart #chartSitePower [data]="chartSitePowerData" [chartType]="'ColumnChart'"
                            [chartoptions]="chartSitePowerOptions" [chartStyle]="'height: 100%'">
                        </app-frms-chart>
                    </div>
                </div>          
                <div class="chart-container chart_issue_type" *ngIf="chartIssueTypeData && showChartIssues"
                    style="height: 300px;" [@enterAnimation]>
                    <app-frms-chart [data]="chartIssueTypeData" [chartType]="'ColumnChart'"
                        [chartoptions]="chartIssueTypeOptions" [chartStyle]="'height: 100%'"></app-frms-chart>
                </div>
                <div class="chart-container" *ngIf="chartIssueRelevanceData && showChartRelevance" [@enterAnimation]>
                    <app-frms-chart [data]="chartIssueRelevanceData" [chartType]="'PieChart'"
                        [chartoptions]="chartIssueRelevanceOptions"></app-frms-chart>
                </div>
                <div class="chart-container" *ngIf="chartIssueModuleBrandData && showChartManufacturer" [@enterAnimation]>
                    <app-frms-chart [data]="chartIssueModuleBrandData" [chartType]="'PieChart'"
                        [chartoptions]="chartIssueModuleBrandOptions">
                    </app-frms-chart>
                </div>
                <div class="chart-container" *ngIf="chartIssueModuleTypeData && showChartPanelModel" [@enterAnimation]>
                    <app-frms-chart [data]="chartIssueModuleTypeData" [chartType]="'PieChart'"
                        [chartoptions]="chartIssueModuleTypeOptions">
                    </app-frms-chart>
                </div>


            </perfect-scrollbar>

        </div>


    </div>

</div>